import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';
import {
  addEventTemplate,
  editEventTemplate,
} from '@pingum/app-state-management/eventTemplate/actions';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Save } from '@mui/icons-material';
import styles from './styles';

import ArchiveDeleteEventTemplateModal from '../ArchiveDeleteEventTemplateModal';
import RestoreEventTemplateModal from '../RestoreEventTemplateModal';

import { primary } from '../../../../../utils/brandColors';
import ChildTasks from './components/ChildTasks';
import GeneralForm from './components/GeneralForm';
// import StatusesForm from './components/StatusesForm';

const resetState = (eventTemplate, barn) => {
  let defaultWorkflowStatuses = null;
  if (!eventTemplate.workflowStatuses && barn && barn.barnMetadata && barn.barnMetadata.statusStartId
    && barn.barnMetadata.statusPendingId && barn.barnMetadata.statusEndId) {
    defaultWorkflowStatuses = [
      {
        statusId: barn.barnMetadata.statusStartId,
        order: 0,
        startingStatus: true,
        requiredAssignment: false,
        nextStatusOptions: [barn.barnMetadata.statusPendingId, barn.barnMetadata.statusEndId],
      },
      {
        statusId: barn.barnMetadata.statusPendingId,
        order: 1,
        startingStatus: false,
        requiredAssignment: false,
        nextStatusOptions: [barn.barnMetadata.statusEndId],
      },
      {
        statusId: barn.barnMetadata.statusEndId,
        order: 2,
        startingStatus: false,
        requiredAssignment: false,
        nextStatusOptions: [barn.barnMetadata.statusPendingId],
      },
    ];
  }
  return {
    id: eventTemplate.id,
    showAdvanced: false,
    name: eventTemplate.id
      ? eventTemplate.name
      : '',
    description: eventTemplate.id
      ? eventTemplate.description
      : '',
    defaultStartStatus: defaultWorkflowStatuses
      ? { id: parseInt(defaultWorkflowStatuses[0].statusId, 10) }
      : eventTemplate.defaultStartStatus,
    eventData: eventTemplate.id
      ? eventTemplate.eventData
      : {},
    eventDataDefaultValues: eventTemplate.id
      ? eventTemplate.eventDataDefaultValues
      : {
        calendarDisplayColor: primary[500],
        advanceNotice: '0',
      },
    dueDateWorkingTime: eventTemplate.dueDateWorkingTime,
    tags: eventTemplate.tags || [],
    children: eventTemplate.children
      ? eventTemplate.children
      : [],
    configurableTags: eventTemplate.configurableTags || true,
    configurableName: eventTemplate.configurableName || true,
    configurableStartStatus: true,
    allowActiveDuplicates: eventTemplate.allowActiveDuplicates || true,
    dueDateDefaultTime: !eventTemplate.id
      ? 43200000 // default 12 hours
      : eventTemplate.dueDateDefaultTime || 0,
    dueDateDefaultTimeEndOfDay: !eventTemplate.id
      ? false
      : eventTemplate.dueDateDefaultTimeEndOfDay,
    dueDateStatusChangeId: eventTemplate.dueDateStatusChangeId || null,
    workflowStatuses: defaultWorkflowStatuses || eventTemplate.workflowStatuses,
    validation: {
      hasChanged: eventTemplate.id, // if we are copying this will be null
      name: {
        hasChanged: !!eventTemplate.name,
        isValid: true,
        message: '',
      },
      description: {
        isValid: true,
        message: '',
      },
      defaultStartStatus: { hasChanged: defaultWorkflowStatuses || (eventTemplate.defaultStartStatus && eventTemplate.defaultStartStatus.id) },
      tags: { isValid: eventTemplate.tags && eventTemplate.tags.length > 0 },
    },
    openArchiveDeleteModal: false,
    openRestoreModal: false,
    selectedEventTemplateId: null,
    snackbar: null,
  };
};

export class EventTemplateEditorComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = resetState(this.props.eventTemplate, this.props.barn);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.eventTemplate !== this.props.eventTemplate) {
      this.setState(resetState(this.props.eventTemplate, this.props.barn));
    }
  }

  handleNameChange = (e) => {
    const changedValue = e.target.value;
    const isValid
      = changedValue !== null
      && changedValue !== undefined
      && changedValue.length >= 2
      && changedValue.length <= 50;
    this.setState((prevState) => ({
      name: changedValue,
      validation: {
        ...prevState.validation,
        name: {
          hasChanged: true,
          isValid,
          message: !isValid
            ? <span><br />Please provide a valid name (between 2 and 50 characters in length).</span>
            : '',
        },
      },
    }));
  }

  handleDescriptionChange = (e) => {
    const changedValue = e.target.value || '';
    const isValid
      = (changedValue === '' || (changedValue.length <= 1024 && changedValue.length >= 2));
    this.setState((prevState) => ({
      description: changedValue,
      validation: {
        ...prevState.validation,
        description: {
          isValid,
          message: !isValid
            ? <span><br />Please provide a valid description (between 2 and 1024 characters in length).</span>
            : '',
        },
      },
    }));
  }

  // handleDefaultStartStatusChange = (defaultStartStatus) => {
  //   this.setState((prevState) => ({
  //     defaultStartStatus,
  //     validation: {
  //       ...prevState.validation,
  //       defaultStartStatus: { hasChanged: true },
  //     },
  //   }));
  // }

  handleChangeTags = (selectedItems) => {
    this.setState(() => ({ tags: selectedItems }));
  }

  // handleChangeEventData = (eventData) => {
  //   this.setState({ eventData });
  // }

  handleChangeEventDataDefaultValues = (eventDataDefaultValues) => {
    this.setState({ eventDataDefaultValues });
  }

  handleChangeDueDateWorkingTime = (dueDateWorkingTime) => {
    this.setState({ dueDateWorkingTime });
  }

  handleChangeDueDateDefaultTime = (dueDateDefaultTime, dueDateDefaultTimeEndOfDay = false) => {
    this.setState({
      dueDateDefaultTime,
      dueDateDefaultTimeEndOfDay,
    });
  }

  handleChangeDateStatusChangeId = (dueDateStatusChangeId) => {
    this.setState({ dueDateStatusChangeId });
  }

  // handleChangeWorkflowStatuses = (workflowStatuses) => {
  //   this.setState({ workflowStatuses });
  // }

  handleChangeChildren = (children) => {
    // don't let self be child
    this.setState({ children: children.filter((c) => !this.props.eventTemplate.id || c.id !== this.props.eventTemplate.id) });
  }

  handleCloseArchiveDeleteModal = (backToList) => {
    this.setState({
      selectedEventTemplateId: null,
      openArchiveDeleteModal: false,
    });
    if (backToList) {
      if (this.props.onClose && this.props.modal) { this.props.onClose(); } else { this.props.navigate('/settings/calendar'); }
    }
  }

  handleCloseRestoreModal = (backToList) => {
    this.setState({
      selectedEventTemplateId: null,
      openRestoreModal: false,
    });
    if (backToList) {
      if (this.props.onClose && this.props.modal) { this.props.onClose(); } else { this.props.navigate('/settings/calendar'); }
    }
  }

  handleOpenArchiveDeleteModal = (eventTemplateId) => {
    this.setState({
      selectedEventTemplateId: eventTemplateId,
      openArchiveDeleteModal: true,
    });
  }

  handleOpenRestoreModal = (eventTemplateId) => {
    this.setState({
      selectedEventTemplateId: eventTemplateId,
      openRestoreModal: true,
    });
  }

  showActionButtons = () => this.state.validation.name.hasChanged
    && this.state.validation.defaultStartStatus.hasChanged
    && this.state.validation.name.isValid && this.state.validation.description.isValid

  submitEventTemplate = () => {
    const request = {
      name: this.state.name,
      description: this.state.description || '',
      defaultStartStatusId: this.state.defaultStartStatus.id,
      tags: [this.props.barn.barnMetadata.eventTaskTypeTagId, ...this.state.tags.map((t) => t.id)],
      children: this.state.children.map((et) => et.id),
      eventData: null,
      eventDataDefaultValues: this.state.eventDataDefaultValues,
      configurableTags: this.state.configurableTags,
      configurableName: this.state.configurableName,
      configurableStartStatus: true,
      allowActiveDuplicates: this.state.allowActiveDuplicates,
      dueDateDefaultTime: this.state.dueDateDefaultTime || 0,
      dueDateDefaultTimeEndOfDay: this.state.dueDateDefaultTimeEndOfDay || false,
      dueDateWorkingTime: this.state.dueDateWorkingTime,
      dueDateStatusChangeId: this.state.dueDateStatusChangeId,
      workflowStatuses: this.state.workflowStatuses,
    };

    if (this.props.eventTemplate.id) {
      this.props.editEventTemplate(this.props.eventTemplate.id, request).then((updatedEventTemplate) => {
        if (this.props.onClose && this.props.modal) { this.props.onClose(updatedEventTemplate); } else { this.props.navigate('/settings/calendar'); }
      }).catch((error) => {
        console.error(error);
        this.setState({
          snackbar: {
            children: 'Error while saving calendar event',
            severity: 'error',
          },
        });
      });
    } else {
      this.props.addEventTemplate(request).then((newEventTemplate) => {
        if (this.props.onClose && this.props.modal) { this.props.onClose(newEventTemplate); } else { this.props.navigate('/settings/calendar'); }
      }).catch((error) => {
        console.error(error);
        this.setState({
          snackbar: {
            children: 'Error while saving calendar event',
            severity: 'error',
          },
        });
      });
    }
  }

  render() {
    const {
      eventTemplate,
      barn,
      isLoading,
      tagTypes,
      eventData,
      // statuses,
      modal,
      onClose,
    } = this.props;

    const isArchived = !!eventTemplate.archived;
    const {
      openArchiveDeleteModal,
      openRestoreModal,
      selectedEventTemplateId,
      snackbar,
    } = this.state;

    const title = eventTemplate.id
      ? 'Edit Calendar Type'
      : 'Create New Calendar Type';

    const handleBack = () => {
      if (onClose && modal) {
        onClose();
      } else {
        this.props.navigate(-1);
      }
    };

    return (
      <Box
        sx={{
          maxWidth: 1200,
          mx: 'auto',
          width: '100%',
          p: {
            xs: 2,
            md: 3,
          },
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <Stack spacing={2}>
          <Stack
            direction={{
              xs: 'column',
              md: 'row',
            }}
            spacing={2}
            alignItems={{
              xs: 'flex-start',
              md: 'center',
            }}
            justifyContent="space-between"
          >
            <Stack spacing={1}>
              <Button
                startIcon={<ArrowBackIcon />}
                onClick={handleBack}
                size="small"
                color="secondary"
                variant="outlined"
              >
                Back
              </Button>
              <Typography variant="h4" component="div">
                {title}
              </Typography>
            </Stack>
          </Stack>
          {isArchived && (
            <Alert severity="warning">
              This task type is archived. Restore it to make edits available across the app.
            </Alert>
          )}
          {isLoading && <LinearProgress sx={{ borderRadius: 999 }} />}

          <Box component="form" autoComplete="off">
            <Stack spacing={3}>
              <GeneralForm
                eventTemplate={this.state}
                tags={this.state.tags}
                tagTypes={tagTypes}
                eventData={eventData}
                handleNameChange={this.handleNameChange}
                handleChangeTags={this.handleChangeTags}
                handleDescriptionChange={this.handleDescriptionChange}
                handleChangeEventDataDefaultValues={this.handleChangeEventDataDefaultValues}
                isLoading={isLoading}
              />
              <ChildTasks
                eventTemplate={this.state}
                barn={barn}
                handleChangeChildren={this.handleChangeChildren}
                statusEndId={barn.barnMetadata.statusEndId}
                handleChangeEventDataDefaultValues={this.handleChangeEventDataDefaultValues}
                handleChangeDueDateDefaultTime={this.handleChangeDueDateDefaultTime}
                handleChangeDueDateWorkingTime={this.handleChangeDueDateWorkingTime}
                handleChangeDateStatusChangeId={this.handleChangeDateStatusChangeId}
                isLoading={isLoading}
                navigate={this.props.navigate}
              />
            </Stack>
          </Box>
        </Stack>
        <Paper
          elevation={4}
          sx={{
            mt: 4,
            px: 2,
            py: 1.5,
            display: 'flex',
            justifyContent: 'space-between',
            gap: 1,
            position: 'sticky',
            bottom: 0,
            zIndex: 5,
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            boxShadow: 12,
            backgroundColor: 'background.paper',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 1,
            }}
          >
            <Button onClick={() => { if (onClose && modal) { onClose(); } else { this.props.navigate('/settings/tasks'); } }}>
              Cancel
            </Button>
            {eventTemplate.id && (!eventTemplate.archived
              ? (
                <Button
                  color="inherit"
                  onClick={() => { this.handleOpenArchiveDeleteModal(eventTemplate.id); }}
                >
                  Delete
                </Button>
              )
              : (
                <Button
                  color="secondary"
                  onClick={() => { this.handleOpenRestoreModal(eventTemplate.id); }}
                >
                  Restore
                </Button>
              ))}
          </Box>
          <Button
            disabled={!this.showActionButtons()}
            id="submit-event-modal-button"
            onClick={this.submitEventTemplate}
            color="primary"
            variant="contained"
            startIcon={<Save />}
          >
            {eventTemplate.id
              ? 'Update Calendar Event Type'
              : 'Create Calendar Event Type'}
          </Button>
        </Paper>

        <ArchiveDeleteEventTemplateModal
          eventTemplateIds={[selectedEventTemplateId]}
          handleCloseModal={this.handleCloseArchiveDeleteModal}
          isOpen={openArchiveDeleteModal}
        />
        <RestoreEventTemplateModal
          eventTemplateIds={[selectedEventTemplateId]}
          handleCloseModal={this.handleCloseRestoreModal}
          isOpen={openRestoreModal}
        />

        {
          !!snackbar && (
            <Snackbar
              open
              onClose={() => { this.setState({ snackbar: null }); }}
              autoHideDuration={6000}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            >
              <Alert {...snackbar} onClose={() => { this.setState({ snackbar: null }); }} />
            </Snackbar>
          )
        }
      </Box>
    );
  }
}

EventTemplateEditorComponent.propTypes = {
  classes: PropTypes.object,
  eventTemplate: PropTypes.object,
  barn: PropTypes.object,
  addEventTemplate: PropTypes.func,
  editEventTemplate: PropTypes.func,
  statuses: PropTypes.array,
  eventData: PropTypes.array,
  tags: PropTypes.array,
  tagTypes: PropTypes.array,
  navigate: PropTypes.func,
  isLoading: PropTypes.bool,
  isEditing: PropTypes.bool,
  isAdding: PropTypes.bool,
  errors: PropTypes.number,
  modal: PropTypes.bool,
  onClose: PropTypes.func,
};

EventTemplateEditorComponent.defaultProps = {
  classes: {},
  barn: { barnMetadata: {} },
  navigate: () => { },
  eventTemplate: {
    name: '',
    description: '',
    eventData: [],
    tags: [],
    allowActiveDuplicates: true,
    eventDataDefaultValues: {},
    workflowStatuses: [],
    configurableTags: true,
    configurableName: true,
    configurableStartStatus: true,
    defaultStartStatus: {
      id: 0,
      name: 'Select A Value...',
      icon: 'search',
      iconColor: 'gray',
    },
  },
  addEventTemplate: () => { },
  editEventTemplate: () => { },
  statuses: [],
  eventData: [],
  tags: [],
  tagTypes: [],
  isLoading: true,
  isEditing: false,
  isAdding: false,
  errors: 0,
  modal: false,
  onClose: null,
};

export const mapStateToProps = (state) => ({
  barn: state.barn.selectedBarn,
  statuses: state.status.statuses,
  eventData: state.eventData.eventData,
  tags: state.tag.tags,
  tagTypes: state.tagType.tagTypes,
  isEditing: state.eventTemplate.isEditingEventTemplate,
  isAdding: state.eventTemplate.isAddingEventTemplate,
  errors: state.error.errorMessages.length,
});

export const mapDispatchToProps = (dispatch) => ({
  addEventTemplate: (request) => dispatch(addEventTemplate(request)),
  editEventTemplate: (eventTemplateId, request) => dispatch(editEventTemplate(eventTemplateId, request)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(EventTemplateEditorComponent));
